module.exports = __webpack_public_path__ + "static/media/Background.18137148.png";